import React, { useEffect } from 'react'

import JobListingHeaderInternal from './JobListingHeaderInternal'
import JobListingContentInternal from './JobListingContentInternal'

const JobListingInternalPage = ({
  title,
  message,
  locationType,
  authed = false,
  html,
}) => {
  useEffect(() => {
    document.title = title
  }, [title, message, locationType])

  return (
    <>
      <JobListingHeaderInternal
        locationType={locationType}
        message={message}
        headerText={title + ' Search'}
        authed={authed}
        html={html}
      />
      <JobListingContentInternal locationType={locationType} authed={authed} />
    </>
  )
}

export default JobListingInternalPage
